import type { EmailContext } from "../types";

interface ContextHeaderProps {
  context: EmailContext;
}

function formatDate(date: Date | null): string {
  if (!date) return "";
  return new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date instanceof Date ? date : new Date(date));
}

export function ContextHeader({ context }: ContextHeaderProps) {
  return (
    <div className="context-header">
      <div className="context-subject" title={context.subject}>
        {context.subject || "(Kein Betreff)"}
      </div>
      <div className="context-meta">
        <span className="context-sender">
          {context.sender.displayName || context.sender.emailAddress}
        </span>
        {context.dateTimeCreated && (
          <span className="context-date">
            {formatDate(context.dateTimeCreated)}
          </span>
        )}
      </div>
    </div>
  );
}
